<div class="add-Stock-modal" >
  <div class="modal-header">
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="handleModalHide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body" style="display: flex; justify-content: center; align-items: center;">
    <form [formGroup]="addStockForm" (ngSubmit)="onContinue()">
      <div class="info">
        <h2>Add Products to Stock</h2>

          <div class="add-stock">
            <div class="col-10">
              <label>Add Stock</label>
              <input class="form-control" formControlName="stock" type="number" />
              <span *ngIf="
              addStockForm.controls['stock'].hasError('required') &&
              addStockForm.controls['stock'].touched"
              class="error">Stock is required</span>
              <span *ngIf="
              addStockForm.controls['stock'].hasError('pattern')&&
              addStockForm.controls['stock'].touched"
              class="error">only digits allowed</span>
            </div>
          </div>
          <div class="add-foc">
            <div class="col-10">
              <label>Add FOC</label>
              <input class="form-control" formControlName="foc" type="number" />
              <span *ngIf="
              addStockForm.controls['foc'].hasError('required') &&
              addStockForm.controls['foc'].touched"
              class="error">FOC is required</span>
              <span *ngIf="
              addStockForm.controls['foc'].hasError('pattern')&&
              addStockForm.controls['foc'].touched"
              class="error">only digits allowed</span>
            </div>
          </div>
          <div class="reset-empty-box">
            <div class="col-10">
              <label class="mr-6 mb-0" for="anon-check">Reset Empty Box?</label>
              <label class="custom-toggle custom-toggle-default">
                <input
                  type="checkbox"
                  formControlName="isResetEmptyBox"
                />
                <span
                  class="custom-toggle-slider rounded-circle"
                  data-label-off="No"
                  data-label-on="Yes"
                >
                </span>
              </label>
            </div>
          </div>
      </div>
      <div class="modal-footer"style="display: flex; justify-content: center; align-items: center;">
        <button class="btn btn-primary" [disabled]="addStockForm.invalid" >
          Confirm
        </button>
      </div>
    </form>
  </div>
</div>

